var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGeneral(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "db64d19ed0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "967c12ec14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 0 C 100.757812 0 30.4375 70.320312 30.4375 157.0625 C 30.4375 243.804688 100.757812 314.125 187.5 314.125 C 274.242188 314.125 344.5625 243.804688 344.5625 157.0625 C 344.5625 70.320312 274.242188 0 187.5 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5e8ad1037b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 79.125 270.328125 L 296 270.328125 L 296 375 L 79.125 375 Z M 79.125 270.328125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "69f3c50b82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 375 L 295.875 270.328125 L 79.125 270.328125 L 187.5 375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25d877ea61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d4add79ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 8.738281 C 104.800781 8.738281 37.757812 75.78125 37.757812 158.480469 C 37.757812 241.179688 104.800781 308.222656 187.5 308.222656 C 270.199219 308.222656 337.242188 241.179688 337.242188 158.480469 C 337.242188 75.78125 270.199219 8.738281 187.5 8.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d625a1644"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84.175781 266.46875 L 291 266.46875 L 291 367 L 84.175781 367 Z M 84.175781 266.46875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0641a81c86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 366.261719 L 290.824219 266.46875 L 84.175781 266.46875 L 187.5 366.261719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd6d981de1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8dd12fbb45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 19.507812 C 110.746094 19.507812 48.527344 81.726562 48.527344 158.480469 C 48.527344 235.234375 110.746094 297.453125 187.5 297.453125 C 264.253906 297.453125 326.472656 235.234375 326.472656 158.480469 C 326.472656 81.726562 264.253906 19.507812 187.5 19.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7d2f76c73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 160 68.738281 L 215 68.738281 L 215 199 L 160 199 Z M 160 68.738281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8dab22a7b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 195.632812 191.367188 L 214.09375 101.339844 C 215.730469 93.347656 213.691406 85.046875 208.535156 78.726562 C 203.378906 72.40625 195.65625 68.738281 187.5 68.738281 C 179.34375 68.738281 171.621094 72.40625 166.464844 78.726562 C 161.308594 85.046875 159.269531 93.347656 160.90625 101.339844 L 179.367188 191.367188 C 180.15625 195.230469 183.558594 198.003906 187.5 198.003906 C 191.441406 198.003906 194.84375 195.230469 195.632812 191.367188 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6affcdb46f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170.320312 213.863281 L 204.679688 213.863281 L 204.679688 248.222656 L 170.320312 248.222656 Z M 170.320312 213.863281 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8ca3f422c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 213.863281 C 178.011719 213.863281 170.320312 221.554688 170.320312 231.042969 C 170.320312 240.53125 178.011719 248.222656 187.5 248.222656 C 196.988281 248.222656 204.679688 240.53125 204.679688 231.042969 C 204.679688 221.554688 196.988281 213.863281 187.5 213.863281 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#db64d19ed0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#967c12ec14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.4375 0 L 344.5625 0 L 344.5625 314.125 L 30.4375 314.125 Z M 30.4375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5e8ad1037b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#69f3c50b82)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 79.125 270.328125 L 296.183594 270.328125 L 296.183594 374.792969 L 79.125 374.792969 Z M 79.125 270.328125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25d877ea61)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d4add79ca)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.757812 8.738281 L 337.242188 8.738281 L 337.242188 308.222656 L 37.757812 308.222656 Z M 37.757812 8.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d625a1644)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0641a81c86)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 84.175781 266.46875 L 291.117188 266.46875 L 291.117188 366.066406 L 84.175781 366.066406 Z M 84.175781 266.46875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd6d981de1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8dd12fbb45)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 48.527344 19.507812 L 326.472656 19.507812 L 326.472656 297.453125 L 48.527344 297.453125 Z M 48.527344 19.507812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7d2f76c73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8dab22a7b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 154.222656 68.738281 L 221.257812 68.738281 L 221.257812 231.300781 L 154.222656 231.300781 Z M 154.222656 68.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6affcdb46f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8ca3f422c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 170.320312 213.863281 L 204.679688 213.863281 L 204.679688 248.222656 L 170.320312 248.222656 Z M 170.320312 213.863281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral);
export default __webpack_public_path__ + "static/media/general.3e946bf687da734691f784c4c3be4a9a.svg";
export { ForwardRef as ReactComponent };